(() => {
  const icon = (name) => {
    const icons = {
      home: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 11.5 12 4l9 7.5"/><path d="M5.5 10.5V20h13v-9.5"/><path d="M9.5 20v-5.5h5V20"/></svg>',
      install: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14.5 6.5a4 4 0 0 0-5-5l2.2 2.2-3 3L6.5 4.5a4 4 0 0 0 5 5L20 18l-2 2-8.5-8.5"/></svg>',
      solar: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="3.2"/><path d="M12 1v2M12 13v2M5 8H3M21 8h-2M6.8 2.8l1.4 1.4M17.2 11.8l1.4 1.4M17.2 4.2l1.4-1.4M6.8 13.2l1.4-1.4"/><path d="M5 19h14l-1.6-4H6.6L5 19Z"/><path d="M12 15v4M8 15l-.7 4M16 15l.7 4"/></svg>',
      car: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 16 1.6-5h10.8l1.6 5"/><path d="M3.5 16h17v4h-2v-2h-13v2h-2v-4Z"/><circle cx="7" cy="16.5" r=".8"/><circle cx="17" cy="16.5" r=".8"/></svg>',
      fleet: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h8v6H3zM13 3h8v6h-8zM13 12h8v6h-8zM3 15h8v6H3z"/></svg>',
      building: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 21V5h10v16M14 9h6v12M8 8h2M8 12h2M8 16h2M17 12h1M17 16h1M2 21h20"/></svg>',
      hotel: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 20V8h18v12M6 8V4h12v4M7 12h3M14 12h3M7 16h3M14 16h3M2 20h20"/></svg>',
      partner: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM16.5 11a3.5 3.5 0 1 0 0-7"/><path d="M2 21v-2a6 6 0 0 1 12 0v2M14 15.5a5 5 0 0 1 8 4V21"/></svg>'
    };
    return icons[name] || icons.home;
  };

  const metaFor = (title) => {
    const t = title.toLowerCase();
    if (t.includes('installation')) return ['install', 'Hardware und Fachbetrieb zusammen'];
    if (t.includes('pv') || t.includes('energie')) return ['solar', 'Solarstrom intelligent ins Auto laden'];
    if (t.includes('dienstwagen') || t.includes('abrechnung')) return ['car', 'Verbrauch erfassen und sauber abrechnen'];
    if (t.includes('unternehmen') || t.includes('flotte')) return ['fleet', 'Skalierbare Ladeinfrastruktur für Betriebe'];
    if (t.includes('wohn') || t.includes('weg')) return ['building', 'Lösungen für mehrere Stellplätze'];
    if (t.includes('hotel') || t.includes('gastronomie')) return ['hotel', 'Gästeladen als Service am Standort'];
    if (t.includes('elektriker') || t.includes('partner')) return ['partner', 'Projekte, Konditionen und technischer Support'];
    return ['home', 'Die passende Ladelösung für Zuhause'];
  };

  const decorate = (root = document) => {
    const summaries = [...root.querySelectorAll('.mega-menu > summary')];
    const summary = summaries.find((el) => el.textContent.trim().toLowerCase() === 'lösungen');
    if (!summary) return;

    const details = summary.closest('.mega-menu');
    if (!details || details.dataset.wwSolutionsReady === 'true') return;
    details.dataset.wwSolutionsReady = 'true';

    const content = details.querySelector('.mega-menu__content');
    const inner = content?.querySelector('.mega-menu__inner');
    const list = inner?.querySelector('.mega-menu__list');
    if (!content || !inner || !list) return;

    content.classList.add('mega-menu__content--ww-solutions');
    list.classList.remove('mega-menu__list--compact', 'mega-menu__list--condensed');
    list.classList.add('ww-solutions-grid');

    const intro = document.createElement('div');
    intro.className = 'ww-solutions-intro';
    intro.innerHTML = '<p class="ww-solutions-intro__eyebrow">Lösungen nach Anwendung</p><p class="ww-solutions-intro__title">Ladeinfrastruktur, die zu Ihrem Alltag oder Projekt passt.</p><p class="ww-solutions-intro__text">Von der privaten Wallbox bis zur skalierbaren Unternehmenslösung – Einstieg direkt über Ihren Anwendungsfall.</p>';
    inner.insertBefore(intro, list);

    list.querySelectorAll(':scope > li > a').forEach((link) => {
      const title = link.textContent.trim();
      const [iconName, desc] = metaFor(title);
      link.classList.add('ww-solution-card');
      link.innerHTML = `<span class="ww-solution-card__icon">${icon(iconName)}</span><span class="ww-solution-card__copy"><span class="ww-solution-card__title"></span><span class="ww-solution-card__desc"></span></span><span class="ww-solution-card__arrow" aria-hidden="true">→</span>`;
      link.querySelector('.ww-solution-card__title').textContent = title;
      link.querySelector('.ww-solution-card__desc').textContent = desc;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => decorate());
  } else {
    decorate();
  }
  document.addEventListener('shopify:section:load', (event) => decorate(event.target));
})();
